import { SystemRootState, useSystemDispatch, useSystemSelector } from '@rahtab/system';
import categoryReducer from './slices/categoriesSlice';
import categoryInventoryReducer from './slices/categoryInventorySlice';
import categoryOrderingReducer from './slices/categoryOrderingSlice';
import correctionListReducer from './slices/correctionListSlice';
import invoicesReducer from './slices/invoicesSlice';
import listingReducer from './slices/listingsSlice';
import loadsReducer from './slices/loadsSlice';
import merchandiseInventoryReducer from './slices/merchandiseInventorySlice';
import merchandiseOrderingReducer from './slices/merchandiseOrderingSlice';
import merchandiseReducer from './slices/merchandisesSlice';
import stockListReducer from './slices/stockListSlice';
import viewerReducer from './slices/viewerSlice';

declare module '@rahtab/system' {
  type AppReducers = typeof reducer;
  interface SystemReducer extends AppReducers {}
}

export const reducer = {
  loads: loadsReducer,
  viewer: viewerReducer,
  invoices: invoicesReducer,
  merchandiseInventory: merchandiseInventoryReducer,
  merchandise: merchandiseReducer,
  merchandiseOrdering: merchandiseOrderingReducer,
  categoryInventory: categoryInventoryReducer,
  category: categoryReducer,
  categoryOrdering: categoryOrderingReducer,
  correctionList: correctionListReducer,
  listings: listingReducer,
  stockList: stockListReducer,
};

export type RootState = SystemRootState;

export const useAppDispatch = useSystemDispatch;

export const useSelector = useSystemSelector;
